import { observer } from 'mobx-react'
import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import patient from '../stores/patient'

@observer
class WithReadonlyPatient extends Component {
  render() {
    const { history } = this.props

    // This line is a hack. We just need to scroll top on every page change, and this component is
    // used on every page.
    document.body.scrollTop = document.documentElement.scrollTop = 0

    if (!patient.fields || !patient.readonly) {
      console.log('here');
      patient.reset()
      history.push('/patient-login')
      return null
    }

    return this.props.children
  }
}

export default withRouter(WithReadonlyPatient)



// WEBPACK FOOTER //
// ./src/conditions/WithReadonlyPatient.js